import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const HyundaiGeneratorEngine = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const handleTransProduct = (productName : string) => {
        navigate(`/hyundai/generatorEngine/${productName}`)
    }
    return(
        <>
        <div className="contentBox">
            <ul>
                <li onClick={()=>handleTransProduct('hg401')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hg401.png" alt="HG401 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>HG401 {t("hyundai_1_2")}</span>
                        <span>15kW ~ 20kW / 2,607cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProduct('hg403')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hg403.png" alt="HG403 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>HG403 {t("hyundai_1_2")}</span>
                        <span>24kW ~ 68kW / 3,298~3,907cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProduct('hg404')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hg404.png" alt="HG404 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>HG404 {t("hyundai_1_2")}</span>
                        <span>80kW ~ 100kW / 3,933cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProduct('hg608')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hg608.png" alt="HG608 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>HG608 {t("hyundai_1_2")}</span>
                        <span>110kW ~ 130kW / 5,899cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProduct('hg611')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hg611.png" alt="HG611 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>HG611 {t("hyundai_1_2")}</span>
                        <span>180kW ~ 210kW / 11,149cc</span>
                    </div>
                </li>
                <li onClick={()=>handleTransProduct('hg612')}>
                    <div className="thumbBox">
                        <img src="/assets/images/hg612.png" alt="HG612 시리즈"/>
                    </div>
                    <div className="txtBox">
                        <span>HG612 {t("hyundai_1_2")}</span>
                        <span>330kW / 12,344cc</span>
                    </div>
                </li>
            </ul>
        </div>
        </>
    )
}